import React, { useState, useEffect } from "react";
import { notification, message, Button, Select } from "antd";
import getDetalleVisitaPorTipo from "../../services/visitas_tecnicas/getDetalleVisitasportipoService";
import { postSoportePatti } from "../../services/visitas_tecnicas/postAlmacenarSoportePatti";
import { pdf } from "@react-pdf/renderer";
import PdfAlmacenarConsentimiento from "./Consentimiento/consentimiento_pdf_almacenar";
import PdfAlmacenarDiagnostico from "./Diagnostico/exportable/diagnostico_pdf_almacenar";
import PdfAlmacenarAnalisisCapacidades from "./AnalisisCapacidades/exportable/analisis_capacidades_pdf_almacenar";
import PdfAlmacenarAutorizacionImagen from "./Autorizacion_imagen/exportable.jsx/autorizacion_imagen_pdf_almacenar";
import PdfAlmacenarActaInicio from "./ActaInicio/Acta_inicio_pdf_almacenar";
import { useSelector } from "react-redux";
import getVisitaPorTipoAndCodigo from "../../services/visitas_tecnicas/getVisitaPorTipoAndCodigoService";
import getDetalleActaInicio from "../../services/visitas_tecnicas/getDetalleActaInicio";
import obtenerCategoriasProductos from "../../services/visitas_tecnicas/getCategoriaProductosService";
import getVisitasTecnicas from "../../services/visitas_tecnicas/visita_tecnica/getVisitasTecnicasService";
import PdfAlmacenarVisitaTecnica from "./VisitaTecnica/pdfVisitaTecnicaAlmacenar";
import { postSoporteVisitaTecnicaPatti } from "../../services/visitas_tecnicas/visita_tecnica/postAlmacenarSoporteVisitaTecnicaPaati";
import getNovedades from "../../services/novedades/getNovedades";
import PdfAlmacenarNovedad from "../Novedades/PdfNovedadAlmacenar";
import { postSoporteNovedad } from "../../services/novedades/postAlmacenarSoporteNovedad";
import getVisitaTecnicaById from "../../services/visitas_tecnicas/visita_tecnica/getVisitaTecnicaByIdService";
import getNovedadById from "../../services/novedades/getNovedadByIdService";

const { Option } = Select;

const tipoVisitasDisponibles = [
  { id: 1, nombre: "Consentimiento" },
  { id: 2, nombre: "Diagnostico parte 1" },
  { id: 3, nombre: "Analisis de capacidades" },
  { id: 4, nombre: "Autorización de imagen" },
  { id: 5, nombre: "Acta de inicio" },
  { id: 6, nombre: "Visitas tecnicas" },
  { id: 7, nombre: "Novedades" },


  // Agrega más si los necesitas
];

const tipoVisitasDisponibles_nombre = [
  { id: "Consentimiento", nombre: "Consentimiento" },
  { id: "Diagnostico", nombre: "Diagnostico parte 1" },
  { id: "Capacidades", nombre: "Analisis de capacidades" },
  { id: "Autorizacion", nombre: "Autorización de imagen" },
  { id: "Acta_inicio", nombre: "Acta de inicio" },
  { id: "Visita", nombre: "Visita técnica" },
  { id: "Novedad", nombre: "Novedad" },

  // Agrega más si los necesitas
];

const AutogenerarPdf = () => {
  const [dataCompleta, setDataCompleta] = useState([]);
  const [visitasTecnicas, setVisitasTecnicas] = useState([]);
  const [novedades, setNovedades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tipoVisitaId, setTipoVisitaId] = useState(1);
  const [tipoVisitaNombre, setTipoVisitaNombre] = useState("Consentimiento");
  const usernameFromState = useSelector((state) => state.auth.user);

  const fetchDetalleVisitas = async (id) => {
    try {
      const response = await getDetalleVisitaPorTipo(
        id,
        usernameFromState.email
      );
      const { status, results } = response;

      if (status === 200) {
        const filtrados = results.filter(
          (item) => item.estado_formulario === 1 && item.ruta_pdf === null
        );
        setDataCompleta(filtrados);
      } else {
        notification.error({
          message: "Error",
          description: "No se pudo obtener la información de visitas.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Ocurrió un error al obtener los datos.",
      });
    }
  };


  const fetchVisitasTecnicas = async () => {
    try {
      const response = await getVisitasTecnicas(usernameFromState.email);
      const { status, data } = response;

      if (status === 200) {
        // Filtrar solo las visitas donde ruta_pdf sea null
        const visitasFiltradas = data.filter(visita => visita.ruta_pdf === null  );

        setVisitasTecnicas(visitasFiltradas);
      } else {
        notification.error({
          message: "Error",
          description: message || "Failed to fetch visitas técnicas data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    } finally {
      setLoading(false);
    }
  };


  const fetchNovedades = async () => {
    try {
      const response = await getNovedades(usernameFromState.email);
      const { status, data } = response;
      if (status === 200) {
        // Filtrar solo las novedades donde ruta_pdf sea null
        const novedadesFiltradas = data.filter(novedad => novedad.ruta_pdf === null);
        setNovedades(novedadesFiltradas);
      } else {
        notification.error({
          message: "Error",
          description: message || "Failed to fetch novedades data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    } finally {
      setLoading(false);
    }
  };

  const obtenerDatosCompletosDiagnostico = async (formData) => {
    try {
      const detalle = await getVisitaPorTipoAndCodigo(
        formData.id_participante,
        3
      );

      if (detalle?.detalle) {
        return {
          ...formData,
          firma_tecnico: detalle.detalle.firma_tecnico,
          firma_participante: detalle.detalle.firma_participante,
          tipo_autorizacion: detalle.detalle.tipo_autorizacion,
        };
      } else {
        return formData;
      }
    } catch (error) {
      console.error("Error al obtener datos del diagnóstico:", error);
      return formData; // fallback
    }
  };

  const obtenerDatosCompletosActaInicio = async (formData) => {
    try {
      const detalle = await getDetalleActaInicio(formData.id_participante);
      if (detalle?.success) {
        return detalle.detalle;
      } else {
        return formData;
      }
    } catch (error) {
      console.error("Error al obtener datos del diagnóstico:", error);
      return formData; // fallback
    }
  };

  const cargarCategoriasYProductos = async (productos) => {
    try {
      const response = await obtenerCategoriasProductos();

      if (response.success) {
        // Extraer categorías y productos en mapas para acceso rápido
        const categoriaMap = new Map(
          response.categorias.map((cat) => [cat.id, cat.nombre])
        );
        const productoMap = new Map(
          response.productos.map((prod) => [prod.id, prod.nombre])
        );

        // Verificar que `lista_productos_fortalecimiento_economico` sea un array antes de hacer `.map()`
        if (Array.isArray(productos)) {
          const listaFormateada = productos.map((item) => ({
            categoria: categoriaMap.get(item.categoria) || "Desconocido",
            productos: Array.isArray(item.producto)
              ? item.producto.map(
                (id) => productoMap.get(id) || "Producto Desconocido"
              )
              : [],
          }));
          return listaFormateada;
        } else {
          return [];
        }
      } else {
        console.error(
          "Error al cargar categorías y productos:",
          response.message
        );
      }
    } catch (error) {
      console.error("Error al cargar datos:", error);
    }
  };

    const fetchVisitaTecnicaById_pdf = async (id) => {
      try {
          const response = await getVisitaTecnicaById(id);
          const { status, data } = response;
  
          if (status) {
  
            const { detalle, ...restoData } = data;
  
            const detalleCompleto = {
              ...detalle,
              ...restoData,
            };
  
          return detalleCompleto;
          } else {
           return null;
          }
      } catch (error) {
        notification.error({
          message: "Error",
          description: "An error occurred while fetching data.",
        });
      }
    };

  const fetchNovedadById_pdf = async (id) => {
    try {
      const response = await getNovedadById(id);
      const { status, data } = response;

      if (status) {
        return data;

      } else {
        return null;
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };
  const enviarPDFAlServidor = async (data, id, nombreTipo) => {
    try {
      let datosCompletos = data.detalle;
  
      // 🔍 Procesar según el tipo de documento (por ID)
      if (id === 2) { // Diagnóstico
        datosCompletos = await obtenerDatosCompletosDiagnostico(data.detalle);
  
        // ✅ Validar que existan firmas obligatorias
        const firmaTecnicoValida = typeof datosCompletos?.firma_tecnico === "string" && datosCompletos.firma_tecnico.trim() !== "";
        const firmaParticipanteValida = typeof datosCompletos?.firma_participante === "string" && datosCompletos.firma_participante.trim() !== "";
  
        if (!firmaTecnicoValida || !firmaParticipanteValida) {
          console.warn("⚠️ No se generó el PDF: faltan firmas válidas para diagnóstico.");
          return { status: 400, message: "Faltan firmas válidas para generar el diagnóstico" };
        }
      }
  
      if (id === 5) { // Acta de inicio
        datosCompletos = await obtenerDatosCompletosActaInicio(data.detalle);
      }
  
      if (id === 3) { // Análisis de capacidades
        const responseProductos = await cargarCategoriasYProductos(
          datosCompletos?.lista_productos_fortalecimiento_economico || []
        );
        // 🛒 Agregar productos procesados al formData
        datosCompletos = { ...datosCompletos, productos: responseProductos };
      }

      if( id === 6 ) {// Visitas tecnicas

        datosCompletos = await fetchVisitaTecnicaById_pdf(data.id);

      }
    
      if (id === 7) {
        // 🔗 Enviar la data tal como llega
        datosCompletos = await fetchNovedadById_pdf(data.id) ;
      }
  
      // 🧩 Seleccionar el componente PDF correspondiente según el ID
      const componentesPDF = {
        1: <PdfAlmacenarConsentimiento formData={datosCompletos} />,
        2: <PdfAlmacenarDiagnostico formData={datosCompletos} />,
        3: <PdfAlmacenarAnalisisCapacidades formData={datosCompletos} />,
        4: <PdfAlmacenarAutorizacionImagen formData={datosCompletos} />,
        5: <PdfAlmacenarActaInicio formData={datosCompletos} />,
        6: <PdfAlmacenarVisitaTecnica formData={datosCompletos} />,
        7: <PdfAlmacenarNovedad formData={datosCompletos} />,
      };
  
      const componentePDF = componentesPDF[id];
  
      // ❌ Si no existe componente para el ID, lanzar error
      if (!componentePDF) {
        throw new Error(`No hay componente PDF definido para el tipo de visita con ID ${id}`);
      }
  
      // 🖨️ Generar el PDF en formato Blob
      const blob = await pdf(componentePDF).toBlob();
  
      // 📂 Preparar el FormData para enviar al servidor
      let nombreArchivo = '';
      //Ajustar el nombre del archivo en caso de que sea tipo novedad
      if(id === 7){
         nombreArchivo = `${id}_${nombreTipo}_${data.id}_${data.fecha_archivo}.pdf`;

      }else if(id === 6){
         nombreArchivo = `${id}_${nombreTipo}_${data.numero_visita}_${data.fecha_archivo}.pdf`;

      }else{
        nombreArchivo = `${id}_${nombreTipo}_${data.fecha_archivo}.pdf`;
      }
      const formDataToSend = new FormData();
      formDataToSend.append("ruta", `${data.fecha_directorio}/${data.departamento_p}/${data.codigo_pre}/`);
      formDataToSend.append("nombre_archivo", nombreArchivo);
      formDataToSend.append("file", blob, nombreArchivo);
  
      let response = '';

      // 🚀 Enviar al endpoint correspondiente según el tipo de documento
      if (id === 6) { // Visita técnica
        response = await postSoporteVisitaTecnicaPatti(formDataToSend, data.id);
      } else if (id === 7) { // Novedad
        response = await postSoporteNovedad(formDataToSend, data.id);
      } else { // Otros documentos
        response = await postSoportePatti(formDataToSend, data.id);
      }
  
      // ✅ Devolver la respuesta del servidor
      return response;
  
    } catch (err) {
      // 🛑 Capturar errores y devolver mensaje estándar
      console.error("❌ Error al enviar el PDF:", err);
      return { status: 500, message: "Error al generar o enviar el PDF" };
    }
  };
  
  const onFinish = async () => {
    try {
      setLoading(true);
  
      if (tipoVisitaId === 6 && visitasTecnicas.length > 0) {
        for (const item of visitasTecnicas) {
          const respuestaPDF = await enviarPDFAlServidor(
            item,
            tipoVisitaId,
            tipoVisitaNombre
          );
          if (respuestaPDF?.status === 200) {
            notification.success({
              message: "Registro exitoso",
              description: "PDF generado y almacenado correctamente.",
            });
          } else {
            notification.error({
              message: "Error al subir PDF",
              description:
                "El registro se guardó, pero hubo un problema con el archivo PDF.",
            });
          }
        }
      } else if (tipoVisitaId === 6) {
        console.warn("⚠️ No hay visitas técnicas para procesar.");
      }
  
      if (tipoVisitaId === 7 && novedades.length > 0) {
        for (const item of novedades) {
          const respuestaPDF = await enviarPDFAlServidor(
            item,
            tipoVisitaId,
            tipoVisitaNombre
          );
          if (respuestaPDF?.status === 200) {
            notification.success({
              message: "Registro exitoso",
              description: "PDF generado y almacenado correctamente.",
            });
          } else {
            notification.error({
              message: "Error al subir PDF",
              description:
                "El registro se guardó, pero hubo un problema con el archivo PDF.",
            });
          }
        }
      } else if (tipoVisitaId === 7) {
        console.warn("⚠️ No hay novedades para procesar.");
      }
  
      // Solo procesar dataCompleta si tipoVisitaId es 1, 2, 3, 4 o 5 y si hay datos
      if ([1, 2, 3, 4, 5].includes(tipoVisitaId) && dataCompleta.length > 0) {
        for (const item of dataCompleta) {
          const respuestaPDF = await enviarPDFAlServidor(
            item,
            tipoVisitaId,
            tipoVisitaNombre
          );
          if (respuestaPDF?.status === 200) {
            notification.success({
              message: "Registro exitoso",
              description: "PDF generado y almacenado correctamente.",
            });
          } else {
            notification.error({
              message: "Error al subir PDF",
              description:
                "El registro se guardó, pero hubo un problema con el archivo PDF.",
            });
          }
        }
      } else if ([1, 2, 3, 4, 5].includes(tipoVisitaId)) {
        console.warn("⚠️ No hay datos completos para procesar.");
      }
  
      message.success("Proceso completado.");
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Error",
        description: "Ocurrió un error durante el proceso.",
      });
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    if (tipoVisitaId) {
      const fetchData = async () => {
        setLoading(true);
        if (tipoVisitaId === 6) {
          await fetchVisitasTecnicas();
        } else if (tipoVisitaId === 7) {
          await fetchNovedades();
        } else {
          await fetchDetalleVisitas(tipoVisitaId);
        }
        setLoading(false);
      };
      fetchData();
    }
  }, [tipoVisitaId]);

  return (
    <div style={{ padding: 20 }}>
      <h3>Selecciona el ID de la visita y su tipo</h3>

      <div style={{ display: "flex", gap: 16, marginBottom: 20 }}>
        <div>
          <span>ID de Visita:</span>
          <Select
            style={{ width: 150 }}
            value={tipoVisitaId}
            onChange={(value) => setTipoVisitaId(value)}
          >
            {tipoVisitasDisponibles.map((tipo) => (
              <Option key={tipo.id} value={tipo.id}>
                {tipo.nombre}
              </Option>
            ))}
          </Select>
        </div>

        <div>
          <span>Nombre del Tipo:</span>
          <Select
            style={{ width: 200 }}
            value={tipoVisitaNombre}
            onChange={(value) => setTipoVisitaNombre(value)}
          >
            {tipoVisitasDisponibles_nombre.map((tipo) => (
              <Option key={tipo.id} value={tipo.id}>
                {tipo.nombre}
              </Option>
            ))}
          </Select>
        </div>
      </div>

      {/* Mostrar total de archivos */}
      <div style={{ marginBottom: 16 }}>
        <strong>Total archivos a generar:</strong> {dataCompleta.length}
      </div>

      {tipoVisitaId === 6 && (
        <div style={{ marginBottom: 16 }}>
          <strong>Total visitas técnicas:</strong> {visitasTecnicas.length}
        </div>
      )}


      {tipoVisitaId === 7 && (
        <div style={{ marginBottom: 16 }}>
          <strong>Total Novedades:</strong> {novedades.length}
        </div>
      )}


      <Button type="primary" loading={loading} onClick={onFinish}>
        Generar
      </Button>
    </div>
  );
};

export default AutogenerarPdf;
